import Button from 'Components/Base/Button'
import Icon from 'Components/Base/Icon'
import dayjs from 'dayjs'
import React from 'react'
import Modal from 'react-modal'
import styled from 'styled-components'
import Column from '../Base/Column'
import Row from '../Base/Row'
import Typography from '../Base/Typography'

interface Props {
  modalOpen: boolean
  toggleModal: (isOpen: boolean) => void
  isMobile: boolean
}
export default function MultiFactorModal({ modalOpen, toggleModal, isMobile }: Props) {
  const customStyles = isMobile
    ? {
        content: {
          width: '85%',
          height: 'fit-content',
          overflow: 'none',
          top: '50%',
          left: '50%',
          right: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          borderRadius: '20px',
        },
        overlay: { zIndex: 1000 },
      }
    : {
        content: {
          width: '500px',
          height: 'fit-content',
          overflow: 'none',
          top: '50%',
          left: '50%',
          right: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 2,
          borderRadius: '20px',
        },
        overlay: { zIndex: 1000 },
      }

  const clickExternalLink = (link) => {
    toggleModal(!modalOpen)
    const width = isMobile ? window.outerWidth - 100 : window.outerWidth - 600
    const height = isMobile ? window.outerHeight - 100 : window.outerHeight - 200
    const left = window.screenX + (window.outerWidth - width) / 2
    const top = window.screenY + (window.outerHeight - height) / 2.5
    const title = `Multi-Factor Authentication`
    window.open(link, title, `width=${width},height=${height},left=${left},top=${top}`)
  }

  return (
    <StyledModalContainer style={{ display: modalOpen ? 'block' : 'none' }}>
      <Modal
        isOpen={modalOpen}
        onRequestClose={() => {
          toggleModal(!modalOpen)
          window.localStorage.setItem('snoozeMFADate', dayjs().add(90, 'day').format('MM/DD/YYYY'))
        }}
        style={customStyles}
        ariaHideApp={false}
      >
        <StyledModalHeader>
          <Typography color="white" font="bold" size={24} styles={{ margin: 'auto', textAlign: 'center' }}>
            Protect Your Account
          </Typography>
          <div
            onClick={() => {
              toggleModal(!modalOpen)
              window.localStorage.setItem('snoozeMFADate', dayjs().add(90, 'day').format('MM/DD/YYYY'))
            }}
          >
            <Icon name="times" color="white" size={'2x'} styles={{ alignmentBaseline: 'before-edge', cursor: 'pointer', marginTop: 5 }} />
          </div>
        </StyledModalHeader>
        <Column styles={{ marginBottom: 15, marginTop: isMobile ? 100 : '8vh', textAlign: 'center', paddingLeft: 40, paddingRight: 40 }}>
          <Typography size={18}>
            Add an extra layer of security to your account with multi-factor authentication or an SMS pass code. This will help stop anyone else from
            getting into your account.
          </Typography>

          <Row styles={{ marginTop: 20, marginLeft: 'auto', marginRight: 'auto', width: 180 }}>
            <Button
              text="Get Started"
              onClick={() => clickExternalLink(process.env.REACT_APP_AUTH_MFA_URL)}
              styles={{ height: 50, borderRadius: 0, width: '100%' }}
              hoverColor="#9f2842"
              backgroundColor="#9f2842"
            />
          </Row>
          <Row styles={{ marginTop: 20, marginLeft: 'auto', marginRight: 'auto', width: 180 }}>
            <Button
              text="Skip for Now"
              onClick={() => {
                toggleModal(!modalOpen)
                window.localStorage.setItem('snoozeMFADate', dayjs().add(90, 'day').format('MM/DD/YYYY'))
              }}
              styles={{ height: 50, borderRadius: 0, width: '100%' }}
              hoverColor="#828282"
              backgroundColor="#828282"
            />
          </Row>
          <Row styles={{ marginTop: 40, marginLeft: 'auto', marginRight: 'auto' }}>
            <Typography size={18} font="bold">
              Need Help?
            </Typography>
          </Row>
          <Row
            styles={{ marginLeft: 'auto', marginRight: 'auto', cursor: 'pointer' }}
            onClick={() => clickExternalLink(`https://medchatapp.com/widget/bLZCrHZAnkSVkQoS3dvulQ/chat`)}
          >
            <Typography size={18}>
              <u>Click here</u> for detailed MFA instructions
            </Typography>
          </Row>
        </Column>
      </Modal>
    </StyledModalContainer>
  )
}

const StyledModalContainer = styled.div`
  height: 60px;
  width: 25%;
  position: fixed;
  border-radius: 40px;
  inset: 37% auto 40px 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
`

const StyledModalHeader = styled(Row)`
  background-color: #9f2842;
  position: absolute;
  margin-bottom: 40px;
  height: fit-content;
  width: 100%;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  padding: 10px 20px;
  top: 0;
  left: 0;
  justify-content: space-between;
`
